import styled from "styled-components";

import { SOCIAL_ICONS } from "@src/components/Cards";
import { ReactElement } from "react";

const BRAND_CREAM = "#F2E8CF";

interface SocialType {
  link: string;
  image: ReactElement;
}

const socials: SocialType[] = [
  {
    link: "https://twitter.com/bykusari",
    image: SOCIAL_ICONS.TWITTER,
  },
  {
    link: "https://www.instagram.com/bykusari",
    image: SOCIAL_ICONS.INSTAGRAM,
  },
  {
    link: "https://mirror.xyz/uwucrew.eth",
    image: SOCIAL_ICONS.MIRROR,
  },
];

const Container = styled.div`
  position: relative;
  isolation: isolate;
  background:
    radial-gradient(circle at 12% 18%, rgba(242, 232, 207, 0.18), transparent 28%),
    radial-gradient(circle at 86% 72%, rgba(242, 232, 207, 0.14), transparent 32%),
    ${({ theme }) => theme.colors.green50};
  width: 100%;
  padding: 56px 24px;
  display: flex;
  justify-content: center;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: auto -10% -120px -10%;
    height: 220px;
    background: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.22));
    pointer-events: none;
    z-index: -1;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 750px;
`;

const KusariMark = styled.img`
  width: 130px;
  height: auto;
  margin-bottom: 12px;
`;

const Headline = styled.h3`
  color: ${BRAND_CREAM};
  font-size: clamp(2rem, 6vw, 4rem);
  line-height: 1.05;
  font-weight: 600;
  width: auto;
  margin: 0 0 28px;
`;

const DiscordButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #1f2029;
  color: ${BRAND_CREAM};
  border-radius: 999px;
  padding: 14px 30px;
  text-decoration: none;
  font-weight: 600;
  transition: transform 0.2s ease, background-color 0.2s ease;

  svg {
    width: 20px;
    height: 20px;
    fill: currentColor;
  }

  &:hover {
    transform: translateY(-1px);
    background: #16171d;
  }
`;

const SocialsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 22px;
  gap: 16px;
`;

const SocialLink = styled.a`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;

  svg {
    height: 24px;
    width: 24px;
    color: ${BRAND_CREAM};
    fill: currentColor;
  }

  img {
    display: block;
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
`;

const Footer = () => {
  return (
    <Container>
      <Content>
        <KusariMark src="./images/kusari-mark.png" alt="Kusari logo" />
        <Headline>Discover the Kusari Community</Headline>
        <DiscordButton
          href="https://discord.gg/cKWpT7HGam"
          target="_blank"
          rel="noreferrer"
        >
          {SOCIAL_ICONS.DISCORD}
          join our discord!
        </DiscordButton>
        <SocialsContainer>
          {socials.map((social) => (
            <SocialLink
              key={social.link}
              href={social.link}
              target="_blank"
              rel="noreferrer"
            >
              {social.image}
            </SocialLink>
          ))}
        </SocialsContainer>
      </Content>
    </Container>
  );
};

export default Footer;
